import moment from "moment";
import { poNumberFormate } from "jsFunctions/helperFunctions";
import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";
import { poMonthFormate } from "jsFunctions/helperFunctions";

export const getTdsExcelData = (tdsList) => {
    let list = JSON.parse(JSON.stringify(tdsList));
    const exportData = list.map((data, index) => {
      let content = {
        no: index + 1,
        "Order PO Number": data.poNo && poNumberFormate(data.poNo),
        "Current Order Date":
          data.oDt && moment(data.oDt).format("DD-MMM-YYYY"),
        "Current Order Month": data.om && poMonthFormate(data.om),
        
        "Reference Resource Po" : data?.rfPo,
        "Resource Name": data?.resId?.name,
        "Resource Pan Number": data?.pnNo,
        "Remarks": data?.rmks,
        "Reference Total Amount": `₹ ${data?.tlBlAmt  ? formatAmountIndianRupees(data?.tlBlAmt) : Number(0).toFixed(2)}`,
        "Reference TDS Percent": data?.prc,
        "Reference TDS Amount": `₹ ${data?.tdsAmt  ? formatAmountIndianRupees(data?.tdsAmt) : Number(0).toFixed(2)}`,
        
        "Requested Amount":`₹ ${data.pyInfo?.apAmt  ? formatAmountIndianRupees(data.pyInfo?.apAmt) : Number(0).toFixed(2)}`,
        "Approved Amount":`₹ ${data.pyInfo?.tlAmt  ? formatAmountIndianRupees(data.pyInfo?.tlAmt) : Number(0).toFixed(2)}`,
        
        "Is It Refund Amount?": data?.rfdInfo?.sts ? "true" : "false",
       
      };
      if (data?.pyInfo?.list?.length > 0) {
        data.pyInfo.list.forEach((element, index) => {
          content[`Payment ${index + 1} Spent Amount`] = `₹ ${element?.amt  ? formatAmountIndianRupees(element?.amt) : Number(0).toFixed(2)}`;
          content[`Payment ${index + 1} Bank`] = element?.bnkId?.val;
          content[`Payment ${index + 1} Payee`] = element?.pyId?.val;
          content[`Payment ${index + 1} Date`] = element?.pmtDt &&
            moment(element?.pmtDt).format("DD-MMM-YYYY");
  
        
        });
      }
      content["Space Added"] = "--------------";

      content["Created AT"] = data.crAt ? moment(data.crAt).format("DD-MMM-YYYY") : '';

      return content;
    });
    return exportData;
  };